import "primeicons/primeicons.css";

import "../css/app.css";
import { createApp } from "vue";
import { createPinia } from "pinia";
import { useSettingsStore } from "@/stores/settingsStore";
import { useAuthStore } from "@/stores/auth";
import router from "@/router";
import App from "@/layouts/App.vue";
import { refreshAxios } from "./composables/useApi";
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import i18n from "@/I18n";
import Trans from "@/I18n/translation";
import VCalendar from 'v-calendar';
import "v-calendar/style.css";

import  VueSelect  from "vue-select";
import VueCookies from "vue3-cookies";

import { install } from "vue3-recaptcha-v2";

import { globalCookiesConfig } from "vue3-cookies";

globalCookiesConfig({
    expireTimes: "30d",
    secure: true,
});

function getEtcGmtTimezone() {
    const offset = new Date().getTimezoneOffset();
    const hoursOffset = -(offset / 60);
    const gmtString = `Etc/GMT${hoursOffset >= 0 ? '-' : '+'}${Math.abs(hoursOffset)}`;
    return gmtString;
}

import axios from "axios";

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(VueCookies);
app.use(i18n);
app.use(VueViewer);
app.use(install, {
    sitekey: "6LehbrgqAAAAAGONYIGwSwrib7uH-s4i7JXzqwwr",
    cnDomains: false, // Optional, If you use in China, set this value true
});
app.component("v-select", VueSelect);
app.use(VCalendar, {
    componentPrefix: "v", // Optional, you can change the prefix if needed
});

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["Content-Type"] = "application/json";
window.axios.defaults.headers.common["Accept"] = "application/json";
window.axios.defaults.headers.common["X-localization"] = `${Trans.getPersistedLocale()}`;
window.axios.defaults.headers.common["X-timezone"] = `${getEtcGmtTimezone()}`;
// window.axios.defaults.headers.common["X-timezone"] = "ar";
window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken = true;
axios.defaults.baseURL = "/api/v1/";

refreshAxios();
const settingsStore = useSettingsStore();
const authStore = useAuthStore();


document.querySelector("html").setAttribute("lang", Trans.getPersistedLocale())
document.querySelector("html").setAttribute("dir", Trans.getPersistedLocale()=="ar"?"rtl":"ltr");

settingsStore
    .getApi()
    .catch((error) => {
        console.log("Please login.");
    })
    .finally(() => {
        authStore
            .me()
            .catch((error) => {
                console.log("Please login.");
            })
            .finally(() => {
                app.use(router).mount("#app");
            });
    });
